import { generateUrlParams } from './generateUrlParams';
import { windowIsReady } from './windowIsReady';

export const getMarketingParams = () => {
	const {
		utm_term: utmTerm,
		utm_source: utmSource,
		utm_content: utmContent,
		utm_campaign: utmCampaign,
		campaign_id: campaignId,
		adset_name: adsetName,
		adset_id: adsetId,
		ad_name: adName,
		ad_id: adId,
		ad_placement: adPlacement,
		fbc,
		fbp,
		gclid,
		msclkid,
		twclid,
		ttclid,
		uuid,
	} = generateUrlParams<Record<string, string>>();

	return {
		utmTerm,
		utmSource,
		utmContent,
		utmCampaign,
		campaignId,
		adsetName,
		adsetId,
		adName,
		adId,
		adPlacement,
		fbc,
		fbp,
		gclid,
		msclkid,
		twclid,
		ttclid,
		uuid,
		url: windowIsReady ? window.location.href : '',
	};
};
